<template>
    <div class="alert alert-danger mx-3 my-3" role="alert">
      404 | The path does not exist
    </div>
  </template>
  
  <script setup lang="ts"></script>